'use client';

import React from 'react';
import { Package } from 'lucide-react';
import { PRICE_LISTINGS } from '@/lib/mockData';

interface Props {
  weights: number[];
  selected: number;
  onSelect: (w: number) => void;
  productId: string;
}

export default function WeightSelector({ weights, selected, onSelect, productId }: Props) {
  return (
    <div className="card p-4">
      <div className="flex items-center gap-2 mb-2">
        <Package size={14} className="text-orange-500" />
        <h4 className="font-display font-semibold text-sm text-gray-800">Choisir le format</h4>
      </div>
      <div className="flex flex-wrap gap-2">
        {weights.map((w) => {
          const listings = PRICE_LISTINGS.filter(
            (l) => l.productId === productId && l.weightKg === w && l.stockStatus !== 'out-of-stock'
          );
          const bestPrice = listings.length ? Math.min(...listings.map((l) => l.price)) : null;
          const bestPpkg = listings.length ? Math.min(...listings.map((l) => l.pricePerKg)) : null;

          return (
            <button
              key={`weight-${w}`}
              onClick={() => onSelect(w)}
              className={`flex flex-col items-center px-4 py-2.5 rounded-xl border-2 transition-all duration-150 active:scale-95 ${
                selected === w
                  ? 'border-orange-500 bg-orange-50 text-orange-700' :'border-gray-200 bg-white text-gray-700 hover:border-orange-300 hover:bg-orange-50'
              }`}
            >
              <span className="font-display font-bold text-base tabular-nums">{w} kg</span>
              {bestPrice && (
                <span className="text-xs tabular-nums mt-0.5 font-semibold text-teal-600">
                  {bestPrice.toFixed(2)} €
                </span>
              )}
              {bestPpkg && (
                <span className="text-xs text-gray-400 tabular-nums">
                  {bestPpkg.toFixed(2)} €/kg
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}